// @flow

import { type OutgoingPayment } from '@tectonics/prs/outgoing-payment';
import { type UserInputValues } from '@tectonics/prs/user-input-values';

export async function ewalletOutgoingPaymentMapper(userInputValues: UserInputValues): Promise<$Shape<OutgoingPayment>> {
  return {
    payment_type: 'ewallet',
    payment_type_code: userInputValues['selectedEWallet'],
    instalments: '1',
  };
}
